<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
        @row-save="handleSave"
          @search-change="searchChange"
      >
        <template slot-scope="scope" slot="menu">
          <!--<el-button type="primary"-->
          <!--icon="el-icon-check"-->
          <!--size="small"-->
          <!--plain-->
          <!--v-if="permission.JOINS_SALES_REDPACKET_EDIT"-->
          <!--@click.stop="handleEdit(scope.row,scope.index)"-->
          <!--&gt;编辑-->
          <!--</el-button>-->
          <el-button
            type="success"
            icon="el-icon-check"
            size="small"
            plain
            v-if="scope.row.status == 'WAIT_PAY' "
            @click.stop="openPay(scope.row)"
            >立即付款
          </el-button>
          <el-button
            type="success"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SCANRED"
            @click.stop="func(scope.row)"
            >查看明细
          </el-button>
           <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SCANRED&&scope.row.status=='TO_AUDIT'"
            @click.stop="pass(scope.row.id)"
          >通过
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_SCANRED&&scope.row.status=='TO_AUDIT'"
            @click.stop="refuse(scope.row.id)"
          >拒绝
          </el-button>
          <!-- <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_REDPACKET_EDIT&&scope.row.status=='WAIT_PAY'"
            @click.stop="paySuccess(scope.row.id)"
          >标记为线下付款
          </el-button> -->
        </template>
       
      </avue-crud>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="destroyThisPay">关闭</el-button>
        </el-dialog>
      </template>
      <el-dialog center :visible.sync="dialogBalancePay" width="50%">
        <template slot="title">
          <div>
            <img
              src="../../../../../public/svg/money.svg"
              alt=""
              style="width: 20px; margin-right: 10px"
            />选择付款方式
          </div>
        </template>
        <p style="text-align: center; font-size: 36px">{{ dialogPaymoney }}</p>
        <p style="text-align: center; margin-bottom: 50px">支付金额(元)</p>
        <div style="display: flex; justify-content: space-around">
          <el-radio v-if="!noMoney" v-model="balancePayRadio" label="YE"
            >账户余额({{ getBalance + "元" }})</el-radio
          >
          <el-radio v-if="noMoney" v-model="balancePayRadio" label="BALANCE">
            账户余额(
            <span style="color: red">
              余额不足
              <!-- <a
                href="#"
                style="color:#409EFF;margin-left:3px;text-decoration: underline;"
                @click="toPayMoney"
              >去充值</a> --> </span
            >)
          </el-radio>
          <el-radio v-model="balancePayRadio" label="WX_PAY">微信支付</el-radio>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogBalancePay = false">取 消</el-button>

          <el-button type="primary" @click="listPay">确认支付</el-button>
        </span>
      </el-dialog>
      <template>
       
      </template>
    </basic-container>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import { mapGetters } from "vuex";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
import { scanRedOption } from "@/const/salesCloud/scanRedOption";
//import { scanRedListOption } from "@/const/salesCloud/scanRedListOption";
import {
  agent,
  redPacket,
  withdrawalConfigEdit,
  downloadExcel,
  addRedPacket,
  redPacketPay,
  refuse,
  pass
} from "@/api/salesCloud/scanRed";
import { Image } from "element-ui";
export default {
  name: "scanRed",
  components: {
    VueQr,
  },
  data() {
    return {
      detailStatusList: DIC.SALES_RED_PACKED_DETAIL_STATUS,
      redPacketStatus: DIC.SALES_RED_PACKED_STATUS,
      balancePayRadio: "YE",
      agentId: "",
      tableOption: scanRedOption, //表格设置属性
      //  tableOptionRed: scanRedListOption, //表格设置属性
      tableData: [], //表格的数据
      tableDataRed: [], //表格的数据
      tablePage: 1,
      superiorIds: [],
      superiorId: {},
      categoryTypes: [],
      serviceCategoryName: {},
      tableLoading: false,
      loading: false,
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      url: "http://joinstech-public.oss-cn-shenzhen.aliyuncs.com/7de80e574b428d8e6bc68663e33e1f60,https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      list: [],
      ids: "",
      dialogBalancePay: false,
      redPacketId: "",
      QRCodeDialog: false,
      payRow: {},
      config: {},
      noMoney: true,
      getBalance: 0,
      detailVisible: false,
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      dialogPaymoney: "",
      detailSearch: {},
      formData: {
        promotion: "",
        merchant: "",
        engineer: "",
        server_order: "",
      },
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    searchChange(params) {
    console.log(1)
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      redPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
     pass(id) {
      this.$confirm("确认通过？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          pass(id).then((res) => {
            this.handleList();
          });
        })
        .catch(() => {});
    },
    refuse(id) {
      this.$prompt("请输入原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let data = {};
          data.redPacketId = id;
          data.remarks = value;
          refuse(data).then((res) => {
            this.handleList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    func(row) {
      this.$router.push({
        name: "红包详情",
        path: "/sales/redPacketDetails",
        query: { id: row.id, payment: row.payment },
      });
    },
    
    handleUpdate(row, index, done) {},
    //配置
    redPacket(id) {
      this.agentId = id;
      redPacket({ agentId: id }).then((res) => {
        let data = JSON.parse(res.data).rows;
        this.tableData = data;
      });
    },
    handleSave(row, done) {
      if (null != row.startDate_endDate && undefined != row.startDate_endDate) {
        row.startDate = row.startDate_endDate[0];
        row.endDate = row.startDate_endDate[1];
      }
      addRedPacket(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    //立即支付
    openPay(row) {
      console.log(row);
      this.dialogPaymoney = "";
      this.payRow = row;
      findBalance().then((res) => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        let wxPay = row.payMoney;
        this.dialogPaymoney =  row.redPacketTotal;
        // let wxPay = 1111111;
        console.log(wxPay, this.getBalance);
        this.noMoney = wxPay > this.getBalance;
        this.dialogBalancePay = true;
      });
    },
    //支付
    listPay() {
      if (this.balancePayRadio == "WX_PAY") {
        this.immediatePayment(this.payRow);
      } else {
        let obj = {};
        obj.redPacketId = this.payRow.id;
        obj.payType = "BALANCE";
        redPacketPay(obj).then((res) => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success",
            });
            setTimeout(() => {
              this.handleList();
            }, 2000);
            this.dialogBalancePay = false;
          } else {
            this.$message({
              showClose: true,
              message: "余额不足",
              type: "error",
            });
            this.handleList();
            this.dialogBalancePay = false;
          }
        });
      }
    },
    //微信支付
    immediatePayment(row) {
      console.log(11);
      this.config.value = "";
      let obj = {};
      obj.redPacketId = row.id;
      obj.payType = "WX_PAY";
      redPacketPay(obj).then((response) => {
        console.log(22);
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(() => {
                  _this.QRCodeDialog = false;
                  _this.dialogBalancePay = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success",
                  });
                  _this.handleList();
                  this.handleList();
                }, 2000);
              } else {
                this.QRCodeDialog = false;
                this.dialogBalancePay = false;

                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
              }
              this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.dialogBalancePay = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error",
              });
              this.handleList();
            }
          });

          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;

          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
          // this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    destroyThisPay() {
      this.QRCodeDialog = false;
      this.rechargeDialog = false;
      this.payMoneyDialog = false;
      this.dialogBalancePay = false;
    },
    changeImage(row) {
      console.log(row);
      let str = new Array();
      //   console.log("row：" + JSON.stringify(row));
      // JSON.stringify(row);
      if (row != null) {
        // let picArray = row.split(",");
        let picArray = row;
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      this.list = str;
    },
    formmaterImages(row) {
      let arr = [];
      arr.push(row[0]);
      // if (this.list != null) {
      //   console.log(this.list);
      //   arr = this.list;
      // } else {
      //   console.log(this.list);
      //   arr.push(row[0]);
      // }
      return row;
    },

    formmaterImage(row) {
      let str = new Array();
      //   console.log("row：" + JSON.stringify(row));
      // JSON.stringify(row);
      if (row != null) {
        // let picArray = row.split(",");
        let picArray = row;
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },

    clean() {
      this.currClassify = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
      this.superiorId = {};
      this.serviceCategoryName = {};
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      redPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };

        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      redPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },

    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(page);
      redPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    showDialogTableVisible(rows) {
      this.dialogTableVisible = true;
      this.redPacketId = rows.id;
      console.log(rows);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      this.downloadData = params;
      redPacket(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
  },
};
</script>

    <style lang="scss" scoped>
// /deep/ .el-dialog{
//   height: 300px;
// }
// /deep/ .el-radio__label {
//   font-size: 20px;
// }
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
